import { render, staticRenderFns } from "./tabsCheck.vue?vue&type=template&id=4017a2c4&scoped=true&"
import script from "./tabsCheck.vue?vue&type=script&lang=js&"
export * from "./tabsCheck.vue?vue&type=script&lang=js&"
import style0 from "./tabsCheck.vue?vue&type=style&index=0&id=4017a2c4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4017a2c4",
  null
  
)

export default component.exports